const mutations = {
  mutationButtonActive(state, payload) {
    state.buttonActive = payload;
  },

  mutationShowDescFooter(state, payload) {
    state.showDescFooter = payload;
  },

  mutationFooterTemplate(state, payload) {
    state.footerTemplate = payload;
  },

  mutationHeaderIconLeft(state, payload) {
    state.headerIconLeft = payload;
  },

  mutationHeaderIconRight(state, payload) {
    state.headerIconRight = payload;
  },

  mutationSearchBar(state, payload) {
    state.searchBar = payload;
  },

  mutationSearchBarPlaceholder(state, payload) {
    state.searchBarPlaceholder = payload;
  },

  mutationSearchBarTriggered(state, payload) {
    state.searchBarTriggered = payload;
  },

  mutationSearchBarCondition(state, payload) {
    state.searchBarCondition = payload;
  },

  mutationMobileBodyHeight(state, payload) {
    state.mobileBodyHeight = payload;
  },

  mutationBackLink(state, payload) {
    state.backLink = payload;
  },
};

export default mutations;
